import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import '../common/MdPage.css';
import * as constantClass from '../fileWithConstants';
import { LookupAlumnos } from '../Alumnos/LookupAlumnos';
import { LookupCarreras } from '../Carreras/LookupCarreras';
import * as alumnoCarreraService from '../../services/alumnoCarrera/alumnoCarreraService';
import {
  classifyAlumnoCarreraError,
  isValidAnioInicioCarrera,
  toUpdateAlumnoCarreraPayload,
} from '../../services/alumnoCarrera/alumnoCarreraDto';
import { ChevronLeftIcon } from '../common/mdPageIcons';

export class UpdateAlumnoCarrera extends Component {
  static displayName = UpdateAlumnoCarrera.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      showErrorMessage: false,
      success: false,
      id: this.props.match.params.id,
      errorMessage: '',
      details: this.props.match.params.details,
      alumno: { alumnoDni: '', alumnoCodigo: 0, alumnoNombre: '' },
      carrera: { carreraCod: 0, carreraNombre: '' },
      anioInicio: '',
      showLookupStudent: false,
      showLookupCarreras: false,
    };
  }

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWAlumnosxCarrera');
    if (canAccess) {
      this.populateData();
    }
  }

  handleConfirmButton = () => {
    if (this.isOkToSave()) {
      this.saveStudent();
    } else {
      this.setState({
        showErrorMessage: true,
        errorMessage: 'Los campos Alumno, Carrera y Año de inicio son obligatorios',
      });
    }
  };

  handleShowStudentLookup = () => {
    this.setState({ showLookupStudent: true });
  };

  handleShowCarreraLookup = () => {
    this.setState({ showLookupCarreras: true });
  };

  handleSelectStudentItem = (e) => {
    const studentProperties = e.split('%');
    this.setState({
      alumno: {
        alumnoDni: studentProperties[0],
        alumnoNombre: studentProperties[1],
        alumnoCodigo: parseInt(studentProperties[2], 10),
      },
      showLookupStudent: false,
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleSelectCarreraItem = (e) => {
    const carreraProperties = e.split('%');
    this.setState({
      showLookupCarreras: false,
      carrera: {
        carreraCod: parseInt(carreraProperties[0], 10),
        carreraNombre: carreraProperties[1],
      },
      showErrorMessage: false,
      errorMessage: '',
    });
  };

  handleAnioInicioChange = (e) => {
    const digits = e.target.value.replace(/\D/g, '').slice(0, 4);
    this.setState({ anioInicio: digits, showErrorMessage: false, errorMessage: '' });
  };

  handleHideStudentLookup = () => {
    this.setState({ showLookupStudent: false });
  };

  handleHideCarreraLookup = () => {
    this.setState({ showLookupCarreras: false });
  };

  render() {
    if (this.state.success) {
      return <Redirect to="/md-axc" />;
    }

    const isDetail = this.state.details !== '0';
    const title = isDetail ? 'Detalle del Alumno por Carrera' : 'Modificar Alumno por Carrera';
    const { loading } = this.state;

    return (
      <div className="md-page md-update-axc">
        <Link className="md-page__back-link" to="/md-axc">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 className="md-page__title">{title}</h1>
        </div>
        <p className="md-page__subtitle">
          {isDetail
            ? 'Consulte los datos registrados del alumno por carrera.'
            : 'Actualice el alumno, la carrera o el año de inicio de esta inscripción.'}
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
          {loading ? (
            <div className="md-page__status">Los datos se están actualizando, espere unos segundos...</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field">
            <span className="md-page__field-label">Alumno</span>
            <div className="md-page__picker-block">
              {!isDetail && !loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowStudentLookup}>
                  Seleccionar alumno
                </button>
              ) : null}
              <div className="md-page__picker-fields">
                <div className="md-page__field-readonly">{this.state.alumno.alumnoDni}</div>
                <div className="md-page__field-readonly">{this.state.alumno.alumnoNombre}</div>
              </div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Carrera</span>
            <div className="md-page__picker-block">
              {!isDetail && !loading ? (
                <button type="button" className="md-page__picker-link" onClick={this.handleShowCarreraLookup}>
                  Seleccionar carrera
                </button>
              ) : null}
              <div className="md-page__field-readonly">{this.state.carrera.carreraNombre}</div>
            </div>
          </div>

          <div className="md-page__field">
            <span className="md-page__field-label">Año de inicio en la carrera</span>
            {isDetail ? (
              <div className="md-page__field-readonly">{this.state.anioInicio}</div>
            ) : (
              <input
                className="md-page__field-input md-page__field-input--year"
                type="text"
                inputMode="numeric"
                maxLength={4}
                disabled={loading}
                value={this.state.anioInicio}
                onChange={this.handleAnioInicioChange}
                aria-label="Año de inicio en la carrera"
              />
            )}
          </div>

          {!isDetail ? (
            <div className="md-page__form-actions">
              <button
                type="button"
                className="md-page__form-btn md-page__form-btn--primary"
                onClick={this.handleConfirmButton}
                disabled={loading}
              >
                Guardar cambios
              </button>
            </div>
          ) : null}
        </div>

        {this.state.showLookupStudent ? (
          <LookupAlumnos
            selectStudent={this.handleSelectStudentItem}
            hideLookup={this.handleHideStudentLookup}
          />
        ) : null}
        {this.state.showLookupCarreras ? (
          <LookupCarreras
            selectItem={this.handleSelectCarreraItem}
            hideLookup={this.handleHideCarreraLookup}
          />
        ) : null}
      </div>
    );
  }

  isOkToSave() {
    return (
      this.state.alumno.alumnoDni.length > 0
      && this.state.carrera.carreraNombre.length > 0
      && isValidAnioInicioCarrera(this.state.anioInicio)
    );
  }

  handleAlumnoCarreraError(error, prefix = '') {
    const outcome = classifyAlumnoCarreraError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return { success: false, errorMessage: '' };
    }
    return {
      success: false,
      errorMessage: outcome.message,
    };
  }

  async populateData() {
    try {
      const model = await alumnoCarreraService.getAlumnoCarrera(this.state.id);
      this.setState({
        errorMessage: '',
        alumno: {
          alumnoDni: model.alumnoDni,
          alumnoNombre: model.alumnoNombre,
          alumnoCodigo: model.alumnoCodigo,
        },
        carrera: {
          carreraNombre: model.carreraNombre,
          carreraCod: model.carreraCod,
        },
        anioInicio: model.alumnoxCarreraAnioInicio != null ? String(model.alumnoxCarreraAnioInicio) : '',
      });
    } catch (error) {
      const outcome = this.handleAlumnoCarreraError(error);
      if (outcome.errorMessage) {
        this.setState({ errorMessage: outcome.errorMessage, showErrorMessage: true });
      }
    }
  }

  async saveStudent() {
    this.setState({ showErrorMessage: false, loading: true });
    try {
      await alumnoCarreraService.updateAlumnoCarrera(
        toUpdateAlumnoCarreraPayload({
          id: this.state.id,
          alumnoCodigo: this.state.alumno.alumnoCodigo,
          carreraCod: this.state.carrera.carreraCod,
          anioInicio: this.state.anioInicio,
        })
      );
      this.setState({ loading: false, success: true, errorMessage: '' });
    } catch (error) {
      const outcome = this.handleAlumnoCarreraError(error);
      this.setState({ loading: false, success: false, errorMessage: outcome.errorMessage, showErrorMessage: true });
    }
  }
}
